export const pageStates = {
  verified: "verified",
  registrationSuccess: "registrationSuccess",
  alreadyRegistred: "alreadyRegistred",
  registrationTimeout: "registrationTimeout",
  wrongRegistrationUrl: "wrongRegistrationUrl",
  processCanceled: "processCanceled",
  unknownError: "unknownError"
}